let taskAnimatedGames = null;
var _currCursorPos = {
  x: 1,
  y: 1
};
window[_currCursorPos] = _currCursorPos;

function initAnimatedGamesThumbsMobile(gameEl, gameId) {
  const ua = navigator.userAgent.toLowerCase();
  const isApp = ua.indexOf('ecappdev') > -1;
  if (isApp) return;
  gameEl.addEventListener('touchmove', () => startAnimatedGameThumbnail(gameEl, gameId), {
    passive: true
  });
  gameEl.addEventListener('touchend', () => stopAnimatedGameThumbnailEvent(gameEl, gameId), {
    passive: true
  });
}

function initAnimatedGamesThumbsDesktop(gameEl, gameId) {
  let overHoverTimer;
  gameEl.addEventListener('mouseover', () => {
    if (taskAnimatedGames || !gameEl) return;
    overHoverTimer = setTimeout(() => {
      startAnimatedGameThumbnail(gameEl, gameId);
    }, 300);
  });
  gameEl.addEventListener('mouseleave', () => {
    stopAnimatedGameThumbnailEvent(gameEl, gameId);
    clearTimeout(overHoverTimer);
  });
}

export function initAnimatedGamesThumbs() {
  document.addEventListener('mousemove', (e) => {
    window[_currCursorPos] = {
      x: e.pageX,
      y: e.pageY
    };
  });
}

export function addAnimatedGameThumbs(gameEl, gameId) {
  if (_CMS_MOBILE) initAnimatedGamesThumbsMobile(gameEl, gameId);
  else initAnimatedGamesThumbsDesktop(gameEl, gameId);
}

async function startAnimatedGameThumbnail(gameEl, gameId) {
  gameEl.classList.add('game-hover');
  const { fadeIn, progressBarToFull } = await import('../../../tools/animations.js');
  const { createEl } = await import('../../../tools/basic-functions');
  const activeVideosList = document.querySelectorAll('.game:not(.game-hover) .game-player video');
  for (let i = 0, len = activeVideosList.length; i < len; i++) {
    activeVideosList[i].pause();
    activeVideosList[i].parentNode.parentNode.style.display = 'none';
  }
  if (gameEl.classList.contains('preview-loaded') && gameEl.querySelectorAll('.game-player video').length > 0) {
    if (
      !(gameEl.querySelector('.game-player').style.opacity > 0) &&
      (canPlayAnimatedGameThumbnail(gameEl) || _CMS_MOBILE)
    ) {
      fadeIn(gameEl.querySelector('.game-player'), 'block');
    }
    if (canPlayAnimatedGameThumbnail(gameEl) || _CMS_MOBILE) {
      initTaskAnimatedGames(gameEl);
    }
  } else {
    if (gameEl.getAttribute('data-video-thumb') != 'false' && !gameEl.classList.contains('preview-loaded')) {
      gameEl.classList.add('preview-loaded');
      const vidURL = `/images/uploads/games/previews/${gameId}.mp4`;
      const gameThumb = gameEl.querySelector('.game-thumb');
      const progressBar = createEl('<div class="game-progressbar"><div class="game-progressbar-progress"></div></div>');
      gameThumb.appendChild(progressBar);
      try {
        const response = await fetch(vidURL);
        if (!response.ok) throw new Error(response.statusText);
        else {
          gameThumb.append(
            createEl(
              '<div class="game-player"><div class="video-wrapper"><video loop muted playsinline preload="auto"><source src="' +
                vidURL +
                '" type="video/mp4"></video></div></div>'
            )
          );
          if (canPlayAnimatedGameThumbnail(gameEl) || _CMS_MOBILE) {
            fadeIn(gameEl.querySelector('.game-player'));
            progressBarToFull(gameThumb, 400);
            initTaskAnimatedGames(gameEl);
          } else progressBarToFull(gameThumb, 0);
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      } catch (e) {
        progressBarToFull(gameThumb, 0);
        gameEl.setAttribute('data-video-thumb', 'false');
        console.log('Gameplay clip not found');
      }
    }
  }
}

function canPlayAnimatedGameThumbnail(el) {
  const currCursorPos = window[_currCursorPos];
  const x1 = el.getBoundingClientRect().left + 40;
  const x2 = el.getBoundingClientRect().left + el.getBoundingClientRect().width - 40;
  const y1 = el.getBoundingClientRect().top + window.pageYOffset + 20;
  const y2 = el.getBoundingClientRect().top + el.getBoundingClientRect().height + window.pageYOffset - 20;
  if (currCursorPos.x > x1 && currCursorPos.x < x2 && currCursorPos.y > y1 && currCursorPos.y < y2) return true;
  return false;
}

function stopAnimatedGameThumbnailEvent(gameEl) {
  timerStopAnimatedGameThumbnail(gameEl);
}

async function timerStopAnimatedGameThumbnail(gameEl) {
  clearTaskAnimatedGames();
  gameEl.classList.remove('game-hover');
  if (gameEl.classList.contains('preview-loaded') && gameEl.querySelector('.game-player video')) {
    gameEl.querySelector('.game-player video').pause();
    const { fadeOut, progressBarToFull } = await import('../../../tools/animations.js');
    await fadeOut(gameEl.querySelector('.game-player'));
    const gameThumb = gameEl.querySelector('.game-thumb');
    progressBarToFull(gameThumb, 0);
  }
}

function initTaskAnimatedGames(el) {
  clearTaskAnimatedGames();
  el.querySelector('.game-player video')
    .play()
    .catch((error) => {
      if (error.name !== 'AbortError') {
        console.error(error);
      }
    });
  taskAnimatedGames = setTimeout(() => timerStopAnimatedGameThumbnail(el), 15000);
}

const clearTaskAnimatedGames = () => {
  clearTimeout(taskAnimatedGames);
  taskAnimatedGames = null;
};
